type TOption = {
  value: any;
  label: string;
};

/**
 * @param arrayOfOptions
 * @param valueReplacementKey is the key you want to pass it as value
 * @param labelReplacementKey is the key you want to pass it as label
 * @returns [{ value: any, label: string }]
 * @description returns array of options matched chakra-react-select option format
 */
export const formatOptionsArray = (
  arrayOfOptions: Record<string, any>[],
  valueReplacementKey: string,
  labelReplacementKey: string
): TOption[] | undefined => {
  const options: TOption[] = [];

  if (!arrayOfOptions || !arrayOfOptions?.length) return;

  arrayOfOptions.map((option) => {
    options.push({
      value: option?.[valueReplacementKey],
      label: option?.[labelReplacementKey],
    });
  });

  return options;
};
